import React, { Component, memo, useEffect, useRef } from 'react'

import { useHomeStore } from 'context/HomeStore'
import { ErrorBoundary } from 'asterX-UI'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'

const Filter = () => {
  const { homeStore, homeStoreFunc } = useHomeStore()

  const onChange = e => {
    const { name, value } = e.target
    homeStoreFunc.onFilterChange(name, value)
  }
  const onCheck = e => {
    const { name, checked } = e.target
    homeStoreFunc.onFilterChange(name, checked)
  }

  const filterProps = {
    onChange,
    onCheck,
    onReset: () => homeStoreFunc.onFilterReset(),
    onSearch: () => homeStoreFunc.onSearch(),
    values: homeStore.filter,
    dictionary: homeStore.dictionary,
    loading: homeStore.loading
  }
  return (
    <ErrorBoundary>
      <ImportTouchDesk
        touch={() => import('./layout/Filter.mobile')}
        desktop={() => import('./layout/Filter.desktop')}
      >
        {Component => <Component {...filterProps} />}
      </ImportTouchDesk>
    </ErrorBoundary>
  )
}
export default memo(Filter)
